export default {"src":"/_next/static/media/Milan.cb118747.svg","height":566,"width":361,"blurWidth":0,"blurHeight":0};